var Slideout = {
    $trigger: null,
    $container: null,
    isAnySlideoutActive: false,

    init: function() {
        this.$trigger = $('[data-toggle="slideout"]');
        if ( this.$trigger.length === 0 ) return;

        this.__initEventHandlers();
    },
    __initEventHandlers: function() {
        $(document).on('click', '[data-toggle="slideout"]', function(e) {
            e.preventDefault();
            Slideout.__toggleSlideout($(this));
        });

        $(document).on('click', '.m-slideout__close', function() {
            Slideout.__closeSlideout($(this));
        });

        $(document).on('beforeSlideoutsOpen', function() {
            Slideout.__hideAll();
            Slideout.__toggleBodyOverflow();
        });

        $(document).on('slideoutsClosed', function() {
            Slideout.__toggleBodyOverflow(false);
        });

        $(document).on('click', function(e) {
            Slideout.__detectClickOutside(e);
        });

        $(document).on('keyup', function(e) {
            Slideout.__detectEscapeKey(e);
        });
    },

    __toggleSlideout: function($item) {
        var targetId = $item.data('target');
        if ( targetId === '' ) return;

        var $target = $('.m-slideout#' + targetId);
        if ( $target.length === 0 ) return;

        if ( ! $target.hasClass('is-visible') ) {
            $(document).trigger('beforeSlideoutsOpen');
            $target.addClass('is-visible');
        } else {
            $(document).trigger('beforeSlideoutsClose');
            $target.removeClass('is-visible');
        }

        this.__checkForActiveSlideouts();
    },
    // Close button only
    __closeSlideout: function($item) {
        var $target = $item.closest('.m-slideout');

        if ( ! $target.hasClass('is-visible') ) {
            $(document).trigger('beforeSlideoutsOpen');
            $target.addClass('is-visible');
        } else {
            $(document).trigger('beforeSlideoutsClose');
            $target.removeClass('is-visible');
        }

        this.__checkForActiveSlideouts();
    },

    __detectEscapeKey(e) {
        if ( e.key === 'Escape' ) {
            $(document).trigger('beforeSlideoutsCloseAll');
            $('.m-slideout').removeClass('is-visible');

            this.__checkForActiveSlideouts();
        }
    },

    __detectClickOutside(e) {
        // Make sure we do n othing if we click a trigger button.
        var $toggle = $('[data-toggle="slideout"]');
        if ( $toggle.is(e.target) || $toggle.has(e.target).length !== 0 ) return;

        // Now we can check if we clicked outside the desired elements.
        var $slideout = $('.m-slideout');

        if ( ! $slideout.is(e.target) && $slideout.has(e.target).length === 0 ) {
            $(document).trigger('beforeSlideoutsCloseAll');
            $slideout.removeClass('is-visible');
            this.__checkForActiveSlideouts();
        }
    },

    __checkForActiveSlideouts: function() {
        var active = $('.m-slideout.is-visible').length === 0 ? false : true;

        if ( active ) {
            $(document).trigger('slideoutsOpen');
        } else {
            $(document).trigger('slideoutsClosed');
        }

        return active;
    },

    __toggleBodyOverflow: function(action = true) {
        var overflow = action === true ? 'hidden': 'auto';
        $('body').css('overflow', overflow);
    },

    __hideAll: function() {
        $('.m-slideout').removeClass('is-visible');
    },
}

export default Slideout;



// WEBPACK FOOTER //
// ./scripts/modules/slideout.js